module.exports = "/static/images/logo-buttercream.svg";